import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-about-fs-pro',
    templateUrl: './about-fs-pro.component.html',
    styleUrl: './about.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutFsProComponent {
  @Input() showTiles = true;
}
